'use strict';

// plugin
var canvas = require('./_modules/canvas');
var snowfall = require('./_modules/snowfall');

// modules
var topScratch = require('./_modules/scratch');
var formSelect = require('./_modules/formSelect');
var formHalf = require('./_modules/formHalf');
var recipeModal = require('./_modules/modal');
var shareBtn = require('./_modules/share');

// functions
$('.js-scratch').each(function(){
  var scratch = new Scratch(this);
});

$('.js-select').each(function(){
  var formselect = new FormSelect(this);
});

$('.js-half').each(function(){
  var formhalf = new FormHalf(this);
});

$('.js-recipe-bt').each(function(){
  var recipemodal = new Modal(this);
});

$('.js-share').each(function(){
  var sharebtn = new Share(this);
});

$('.js-swap').on('click', function(){
  $(this).parent().next().removeClass('is-hidden');
  $(this).remove();
});


$(function(){
$('.slider').slick({
autoplay:true,
autoplaySpeed:2000,
dots:true,
pauseOnHover:true
});
});



//////////////////
// WEBPACK FOOTER
// ./js/common.js
// module id = 0
// module chunks = 0